import axios from "axios";
import { SALENG_SHOP_API_PROD } from "../config";

const getAccessToken = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;

  try {
    return JSON.parse(token);
  } catch {
    return token;
  }
};

const apiClient = axios.create();

const clearAuthSession = () => {
  localStorage.removeItem("accessToken");
};

const forceLogout = () => {
  clearAuthSession();
  if (window.location.pathname !== "/auth/login") {
    window.location.replace("/auth/login");
  }
};

export const getAuthorizationHeaders = () => {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

apiClient.interceptors.request.use((config) => {
  const url = config.url || "";
  const isShopApi = url.startsWith(SALENG_SHOP_API_PROD) || url.startsWith("/");

  if (isShopApi) {
    config.headers = config.headers || {};
    Object.assign(config.headers, getAuthorizationHeaders());
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.error || error?.response?.data?.message || "";

    if (status === 403 && /disabled|ปิดการใช้งาน/i.test(message)) {
      forceLogout();
    }

    return Promise.reject(error);
  }
);

export default apiClient;
